import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ClientService } from 'src/app/@core/services/client.service';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() item: any;
  layout: any;

  pageListBuffer: any;
  pageList: any;
  private intervalId: any;
  showPrivacyModal: boolean = false;
  showTermsModal: boolean = false;

  constructor(
    public dataService: DataService,
    public clientService: ClientService
  ) {
  }

  ngOnInit() {
    this.initDefaults();
    this.getLayout();
    this.getPages();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  initDefaults() {
    if (!this.item) {
      this.item = {};
    }
    if (this.item.footerShowSections === undefined) {
      this.item.footerShowSections = true;
    }
    if (this.item.footerShowMyPage === undefined) {
      this.item.footerShowMyPage = true;
    }
    if (this.item.footerShowPrivacyPolicy === undefined) {
      this.item.footerShowPrivacyPolicy = false;
    }
    if (this.item.footerShowTermsOfUse === undefined) {
      this.item.footerShowTermsOfUse = false;
    }
    if (!Array.isArray(this.item.footerPagesItems)) {
      this.item.footerPagesItems = [];
    }
  }

  getLayout() {
    this.dataService.layout()
      .subscribe((res: any) => {
        this.layout = res.data ? res.data.value : null;
      });
  }

  getPages() {
    this.clientService.allPages().subscribe(res => {
      this.pageListBuffer = res.data;
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pageList = [];

        if (this.pageListBuffer && Array.isArray(this.pageListBuffer)) {
          this.pageListBuffer.forEach((section: any) => {
            const copySection = { ...section };
            if (section.pages && Array.isArray(section.pages)) {
              copySection.pagesActive = section.pages.filter((page: any) => {
                if (!this.item || !Array.isArray(this.item.footerPagesItems) || this.item.footerPagesItems.length === 0) {
                  return true;
                }
                for (const activeId of this.item.footerPagesItems) {
                  if (+page.id === +activeId) {
                    return true;
                  }
                }
                return false;
              });
            } else {
              copySection.pagesActive = [];
            }
            this.pageList.push(copySection);
          });
        }
      }, 500);
    });
  }

  openPrivacyModal() {
    this.showPrivacyModal = true;
  }

  closePrivacyModal() {
    this.showPrivacyModal = false;
  }

  openTermsModal() {
    this.showTermsModal = true;
  }

  closeTermsModal() {
    this.showTermsModal = false;
  }

}

